import styled from 'styled-components';

export const Container = styled.div`
  width: ${({ theme }) => theme.containerWidth};
  max-width: ${({ theme }) => theme.containerMaxWidth};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => theme.containerPaddingMobile};
  padding-right: ${({ theme }) => theme.containerPaddingMobile};
  @media (min-width: 768px) {
    padding-left: ${({ theme }) => theme.containerPadding};
    padding-right: ${({ theme }) => theme.containerPadding};
  }
`;
